import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  IconButton,
  MenuItem,
  Popover,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: any) => ({
  iconButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.primary.light,
    '@media (hover: none) and (pointer: coarse)': {
      minWidth: 44,
      minHeight: 44,
    },
  },
}));

type infocomponentProps = {
  onClickEdit?: () => void,
  onClickDelete?: () => void,
  onChangePayees?: () => void,
  onChangePayers?: () => void,
}

const InfoComponent: FC<infocomponentProps> = ({
  onClickDelete,
  onClickEdit,
  onChangePayees,
  onChangePayers
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Box>
      <IconButton
        className={classes.iconButton}
        aria-label={t('orders:entryActionsLabel', { defaultValue: 'Entry actions' })}
        onClick={handleClick}
        size="large"
      >
        <FontAwesomeIcon icon="ellipsis-v" size="sm" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={(e) => {
          e.stopPropagation();
          if (onClickEdit) {
            onClickEdit();
          }
          handleClose();
        }}
        >
          <Typography variant="body2" style={{ fontWeight: 500 }}>{t('orders:editEntryButton')}</Typography>
        </MenuItem>
        {onChangePayees &&
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onChangePayees();
            handleClose();
          }}
          >
            <Typography variant="body2" style={{ fontWeight: 500 }}>{t('orders:changePayeesButton')}</Typography>
          </MenuItem>}
        {onChangePayers &&
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onChangePayers();
            handleClose();
          }}
          >
            <Typography variant="body2" style={{ fontWeight: 500 }}>{t('orders:changePayersButton')}</Typography>
          </MenuItem>}
        {onClickDelete &&
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onClickDelete();
            handleClose();
          }}
          >
            <Typography variant="body2" style={{ fontWeight: 500 }}>{t('orders:deleteEntryButton')}</Typography>
          </MenuItem>}
      </Popover>
    </Box>
  );
};

export default InfoComponent;
